import { Grid } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import SideNavigation from "Layouts/SideNavigationNew/SideNavigation";
import { observer } from "mobx-react";
import React from "react";
import { useLocation } from "react-router-dom";
import theme from "Theme/AppTheme";
import { useStore } from "utils/useStore";
import SearchIcon from "@mui/icons-material/Search";
import ReportsStore from "../Reports/Stores/ReportsStore";

// The items below the divider in the Signals sidebar, shown only in reporting view
const EvalReportingNavItems = observer(() => {
    const { pathname } = useLocation();

    const reportsStore = useStore(ReportsStore);

    const getCurrentNavItem = () => {
        const pathNameArray = pathname.split("/");

        let currentNavItem = `${reportsStore.signalRoutePrefix}/${reportsStore.authStore.orgStore.selectedOrganization?.id}/${reportsStore.currentReport?.id}`;

        if (pathNameArray.includes("dashboard")) {
            currentNavItem = "dashboard/" + currentNavItem;
        }

        return currentNavItem;
    };

    const reportsSearchControls = (
        <>
            <Grid
                item
                style={{
                    paddingTop: theme.spacing(1),
                    paddingBottom: theme.spacing(1),
                    color: theme.palette.gray.main,
                    fontSize: "12px",
                    fontWeight: "bold",
                }}
            >
                ALL REPORTS
            </Grid>

            <Grid item xs={12} sx={{ marginTop: 1 }}>
                <AcxMainTextField
                    placeholderText="Search"
                    onChange={(evt) => {
                        reportsStore.reportsSearchTerm = evt.target.value;
                    }}
                    containerStyle={{
                        fontWeight: theme.typography.fontWeightBold,
                    }}
                    id="report-list-search-box"
                    startAdornment={
                        <SearchIcon
                            sx={{
                                color: "#1F1F1F",
                                opacity: 0.25,
                                marginRight: theme.spacing(1),
                            }}
                        />
                    }
                    value={reportsStore.reportsSearchTerm}
                    fullWidth
                />
            </Grid>
        </>
    );

    return (
        <Grid container sx={{ paddingX: 2 }}>
            {reportsSearchControls}

            <SideNavigation
                items={reportsStore.navStore.itemGroups ?? []}
                currentNavItem={getCurrentNavItem()}
                organizationId=""
                isLoading={reportsStore.getTaskLoading("Load Reports")}
                signalsVariant
            />
        </Grid>
    );
});

export default EvalReportingNavItems;
